<template>
  <div>
    <div class="content">
      <div class="nav flex a-center j-center f-column">
        <div class="nav-title">
          <!-- <div class="nav-title-bg">rongchangyihe</div>
          <div class="nav-titlt-name">网站导览</div>-->
          <img src="../assets/images/catalogue/changpingtixi.png" alt>
        </div>
        <div class="nav-desc">产品模块化，相对独立，模块自由组合，账号统一</div>
        <!-- <div class="nav-warp flex a-center j-center">
                        
        </div>-->
        <div class="nav-main">
          <div class="nav-content flex a-center j-between">
            <div
              class="nav-item flex a-center j-center f-column"
              @mouseenter="activeItem(index)"
              @click="goPath(item.path)"
              v-for="(item,index) in navList"
              :key="index"
            >
              <img
                id="nav-no1"
                :class="{'nav-img-no':activeIdx===index}"
                class="nav-img1"
                :src="item.smallImg"
                alt
              >
              <img id="nav-active1" class="nav-img2"   :class="{'nav-img-active':activeIdx===index}" :src="item.bigImg" alt>
              <div>{{item.name}}</div>
            </div>
          </div>
          <!-- Swiper -->
          <div class="swiper-containers">
            <swiper ref="mySwiper" :options="swiperOptions">
              <swiper-slide>
                <div class="swiper-slides">
                  <div class="item-bg">
                    <img src="../assets/images/商品城/组 6.png" alt>
                  </div>
                  <div
                    class="item-sign1 ani"
                    swiper-animate-effect="bounceInRight"
                    swiper-animate-duration="0.8s"
                    swiper-animate-delay="0s"
                    id="item-sign1"
                  >
                    <img src="../assets/images/商品城/组 9.png" alt>
                  </div>
                  <div
                    class="item-small1 ani"
                    swiper-animate-effect="bounceInLeft"
                    swiper-animate-duration="0.8s"
                    swiper-animate-delay="0s"
                    id="item-small1"
                  >
                    <img src="../assets/images/商品城/组 10.png" alt>
                  </div>
                  <div
                    class="item-desc ani"
                    swiper-animate-effect="bounceInUp"
                    swiper-animate-duration="0.8s"
                    swiper-animate-delay="0.7s"
                    id="item-desc1"
                  >
                    <img src="../assets/images/商品城/组 5.png" alt @click="goPath(navList[0].path)">
                  </div>
                </div>
              </swiper-slide>
              <swiper-slide>
                <div class="swiper-slides flex j-center">
                  <div class="item-bg">
                    <img src="../assets/images/在线学习平台/组 6.png" alt>
                  </div>
                  <div
                    class="item-sign2 ani"
                    swiper-animate-effect="bounceInRight"
                    swiper-animate-duration="0.8s"
                    swiper-animate-delay="0s"
                    id="item-sign2"
                  >
                    <img src="../assets/images/在线学习平台/组 12.png" alt>
                  </div>
                  <div class="item-other">
                    <img class="item-other-img" src="../assets/images/在线学习平台/图 63.png" alt>
                  </div>
                  <div
                    class="item-small2 ani"
                    swiper-animate-effect="bounceInLeft"
                    swiper-animate-duration="0.8s"
                    swiper-animate-delay="0s"
                    id="item-small2"
                  >
                    <img src="../assets/images/在线学习平台/组 11.png" alt>
                    <div class="item-flower">
                      <img class="item-flower-img" src="../assets/images/在线学习平台/图 65.png" alt>
                    </div>
                  </div>
                  <div
                    class="item-desc ani"
                    swiper-animate-effect="bounceInUp"
                    swiper-animate-duration="0.8s"
                    swiper-animate-delay="0.7s"
                    id="item-desc2"
                  >
                    <img id="xixi" src="../assets/images/在线学习平台/海报.png" alt @click="goPath(navList[1].path)">
                  </div>
                </div>
              </swiper-slide>
              <swiper-slide>
                <div class="swiper-slides flex j-center">
                  <div class="item-bg">
                    <img src="../assets/images/实训平台/组 66.png" alt>
                  </div>
                  <div
                    class="item-sign3 ani"
                    swiper-animate-effect="bounceInRight"
                    swiper-animate-duration="0.8s"
                    swiper-animate-delay="0s"
                    id="item-sign3"
                  >
                    <img src="../assets/images/实训平台/组 16.png" alt>
                  </div>
                  <div
                    class="item-small3 ani"
                    swiper-animate-effect="bounceInLeft"
                    swiper-animate-duration="0.8s"
                    swiper-animate-delay="0s"
                    id="item-small3"
                  >
                    <img src="../assets/images/实训平台/组 17.png" alt>
                  </div>
                  <div
                    class="item-desc ani"
                    swiper-animate-effect="bounceInUp"
                    swiper-animate-duration="0.8s"
                    swiper-animate-delay="0.7s"
                    id="item-desc3"
                  >
                    <img src="../assets/images/实训平台/组 5.png" alt @click="goPath(navList[2].path)">
                  </div>
                </div>
              </swiper-slide>
              <swiper-slide>
                <div class="swiper-slides flex j-center">
                  <div class="item-bg">
                    <img src="../assets/images/人才系统/组 6.png" alt>
                  </div>
                  <div
                    class="item-sign4 ani"
                    swiper-animate-effect="bounceInRight"
                    swiper-animate-duration="0.8s"
                    swiper-animate-delay="0s"
                    id="item-sign4"
                  >
                    <img src="../assets/images/人才系统/组 14.png" alt>
                  </div>
                  <div
                    class="item-small4 ani"
                    swiper-animate-effect="bounceInLeft"
                    swiper-animate-duration="0.8s"
                    swiper-animate-delay="0s"
                    id="item-small4"
                  >
                    <img src="../assets/images/人才系统/组 13.png" alt>
                  </div>
                  <div class="item-other">
                    <img src="../assets/images/人才系统/组 15.png" alt>
                  </div>
                  <div
                    class="item-desc ani"
                    swiper-animate-effect="bounceInUp"
                    swiper-animate-duration="0.8s"
                    swiper-animate-delay="0.7s"
                    id="item-desc4"
                  >
                    <img src="../assets/images/人才系统/组 5.png" @click="goPath(navList[3].path)" alt>
                  </div>
                </div>
              </swiper-slide>
              <swiper-slide >
                <div class="swiper-slides flex j-center">
                  <div class="item-bg">
                    <img src="../assets/images/汽车后市场/组 6.png" alt>
                  </div>
                  <div
                    class="item-sign5 ani"
                    swiper-animate-effect="bounceInRight"
                    swiper-animate-duration="0.8s"
                    swiper-animate-delay="0s"
                    id="item-sign5"
                  >
                    <img src="../assets/images/汽车后市场/组 18.png" alt>
                  </div>
                  <div
                    class="item-small5 ani"
                    swiper-animate-effect="bounceInLeft"
                    swiper-animate-duration="0.8s"
                    swiper-animate-delay="0s"
                    id="item-small5"
                  >
                    <img src="../assets/images/汽车后市场/组 19.png" alt>
                  </div>
                  <div
                    class="item-desc ani"
                    swiper-animate-effect="bounceInUp"
                    swiper-animate-duration="0.8s"
                    swiper-animate-delay="0.7s"
                    id="item-desc5"
                  >
                    <img src="../assets/images/汽车后市场/组 5.png" alt @click="goPath(navList[4].path)">
                  </div>
                </div>
              </swiper-slide>
              <swiper-slide>
                <div class="swiper-slides flex j-center">
                  <div class="item-bg">
                    <img src="../assets/images/资源库/组 6.png" alt>
                  </div>
                  <div
                    class="item-sign6 ani"
                    swiper-animate-effect="bounceInRight"
                    swiper-animate-duration="0.8s"
                    swiper-animate-delay="0s"
                    id="item-sign6"
                  >
                    <img src="../assets/images/资源库/组 21.png" alt>
                  </div>
                  <div
                    class="item-small6 ani"
                    swiper-animate-effect="bounceInLeft"
                    swiper-animate-duration="0.8s"
                    swiper-animate-delay="0s"
                    id="item-small6"
                  >
                    <img src="../assets/images/资源库/组 20.png" alt>
                  </div>
                  <div
                    class="item-desc ani"
                    swiper-animate-effect="bounceInUp"
                    swiper-animate-duration="0.8s"
                    swiper-animate-delay="0.7s"
                    id="item-desc6"
                  >
                    <img src="../assets/images/资源库/组 5.png" @click="goPath(navList[5].path)" alt>
                  </div>
                </div>
              </swiper-slide>
              <swiper-slide>
                <div class="swiper-slides flex j-center">
                  <div class="item-bg">
                    <img src="../assets/images/数据管理/组 6.png" alt>
                  </div>
                  <div
                    class="item-sign7 ani"
                    swiper-animate-effect="bounceInRight"
                    swiper-animate-duration="0.8s"
                    swiper-animate-delay="0s"
                    id="item-sign7"
                  >
                    <img src="../assets/images/数据管理/组 23.png" alt>
                  </div>
                  <div
                    class="item-small7 ani"
                    swiper-animate-effect="bounceInLeft"
                    swiper-animate-duration="0.8s"
                    swiper-animate-delay="0s"
                    id="item-small7"
                  >
                    <img src="../assets/images/数据管理/组 22.png" alt>
                  </div>
                  <div
                    class="item-desc ani"
                    swiper-animate-effect="bounceInUp"
                    swiper-animate-duration="0.8s"
                    swiper-animate-delay="0.7s"
                    id="item-desc7"
                  >
                    <img id="xixi" src="../assets/images/数据管理/创新同行.jpg" alt @click="goPath(navList[6].path)">
                  </div>
                </div>
              </swiper-slide>
              <!-- 导航按钮 -->
              <div class="swiper-button-prevs" slot="button-prev">
                <img src="../assets/images/catalogue/left.png" alt @click="prev">
              </div>
              <div class="swiper-button-nexts" slot="button-next">
                <img src="../assets/images/catalogue/right.png" alt @click="next">
              </div>
            </swiper>
          </div>
          <div class="qr-code flex j-center">
            <!-- <img src="../assets/images/catalogue/QR code.png" alt> -->
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Swiper, SwiperSlide, directive } from "vue-awesome-swiper";
import * as swiperAni from "../assets/js/swiper.animate.min.js";
//  import 'swiper/dist/css/swiper.css'
// If you use Swiper 6.0.0 or higher
import "swiper/swiper-bundle.css";
import { constants } from "crypto";
let vm = null;
export default {
  data() {
    return {
      navList: [
        {
          name: "商品城",
          path: "/Electronic-Business",
          smallImg: require("../assets/images/catalogue/icon-small/组 1.png"),
          bigImg: require("../assets/images/catalogue/icon-big/组 1.png")
        },

        {
          name: "学习平台",
          path: "/Learn/learn",
          smallImg: require("../assets/images/catalogue/icon-small/组 2.png"),
          bigImg: require("../assets/images/catalogue/icon-big/组 2.png")
        },
        {
          name: "实训平台",
          path: "/Train",
          smallImg: require("../assets/images/catalogue/icon-small/组 3.png"),
          bigImg: require("../assets/images/catalogue/icon-big/组 3.png")
        },
        
        {
          name: "人才系统",
          path: "/Staff",
          smallImg: require("../assets/images/catalogue/icon-small/组 4.png"),
          bigImg: require("../assets/images/catalogue/icon-big/组 4.png")
        },
        {
          name: "汽车后市场",
          path: "/Learn/market",
          smallImg: require("../assets/images/catalogue/icon-small/组 5.png"),
          bigImg: require("../assets/images/catalogue/icon-big/组 5.png")
        },
        {
          name: "资源库",
          path: "/ResourceLibrary",
          smallImg: require("../assets/images/catalogue/icon-small/组 6.png"),
          bigImg: require("../assets/images/catalogue/icon-big/组 6.png")
        },
        {
          name: "数据管理",
          path: "/ManageSystem/index.htm",
          smallImg: require("../assets/images/catalogue/icon-small/组 7.png"),
          bigImg: require("../assets/images/catalogue/icon-big/组 7.png")
        },
        // {
        //   name: "高清系统",
        //   path: ":440/Login/",
        //   smallImg: require("../assets/images/catalogue/icon-small/组 4.png"),
        //   bigImg: require("../assets/images/catalogue/icon-big/组 4.png")
        // }
      ],
      activeIdx: 0,
      swiperOptions: {
        speed: 400,
        // 变手势
        grabCursor: true,
        navigation: {
          nextEl: ".swiper-button-nexts",
          prevEl: ".swiper-button-prevs"
        },
        on: {
          init: function() {
            swiperAni.swiperAnimateCache(this);
            swiperAni.swiperAnimate(this);
          },
          // slideChange: function() {
          //   swiperAni.swiperAnimate(this);
          // },
          slideChangeTransitionEnd: function() {
            swiperAni.swiperAnimate(this); //每个slide切换结束时也运行当前slide动画
            //this.slides.eq(this.activeIndex).find('.ani').removeClass('ani'); 动画只展现一次，去除ani类名

            vm.activeItem(this.realIndex, true);
          }
        }
        // Some Swiper option/callback...
      }
    };
  },
  components: {
    Swiper,
    SwiperSlide
  },
  directives: {
    swiper: directive
  },
  props: {},
  methods: {
    prev() {
      this.$refs.mySwiper.$swiper.slidePrev(400, true);
    },
    next() {
      this.$refs.mySwiper.$swiper.slideNext(400, true);
    },
    goPath(path) {
      console.log(path)
      // return
      if (path) {
        window.open("https://fangzhen.autotool.com.cn" + path);
        // window.open("https://new.cdrcyh.com.cn" + path);
      } else {
        this.myNotify({
          content: "暂未开放，敬请期待！",
          btn: "关闭"
        });
      }
    },
    activeItem(index, flage) {
      if (this.activeIdx !== index) {
        if (!flage) this.$refs.mySwiper.$swiper.slideToLoop(index, 600, true);
        this.activeIdx = index;
      }
    }
  },
  mounted() {},
  created() {
    vm = this;
  },
  watch: {},
  computed: {
    swiper() {
      return this.$refs.mySwiper.swiper;
    }
  }
};
</script>

<style scoped lang='scss'>
@import "../assets/css/animate.min.css";

#xixi{
  // width: 1000px;
  border-radius: 25px;
}
.content {
  padding: 63px 0;
  margin: 0 auto;
}

.nav-title {
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
}

.nav-title img {
  // width: 420px;
  width: 140px;
  // height: 51px;
  height: 32px;
  object-fit: cover;
}

.nav-warp {
  width: 1460px;
}

.nav-title-bg {
  height: 51px;
  font-size: 56px;
  font-family: FZLanTingHeiS-HN-GB;
  font-weight: 400;
  color: rgba(51, 51, 51, 1);
  line-height: 10px;
  opacity: 0.1;
}

.nav-titlt-name {
  position: absolute;
  bottom: 0;
  left: 50%;
  transform: translateX(-50%);
  font-size: 36px;
  font-family: FZDaLiTiS;
  font-weight: bold;
  color: rgba(46, 51, 58, 1);
  line-height: 77px;
  z-index: 2;
}

.nav-desc {
  font-size: 18px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: rgba(51, 51, 51, 1);
  line-height: 42px;
  margin-bottom: 10px;
  // background-color: red;
}

.nav-content {
  margin: 14px auto;
  width: 1230px;
}

.nav-item:hover {
  cursor: pointer;
}

.nav-item {
  width: 120px;
}

.nav-item > img {
  width: 100px;
  height: 100px;
  background: rgba(246, 246, 246, 1);
  border-radius: 50%;
}

.nav-item > div {
  font-size: 14px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: rgba(51, 51, 51, 1);
  line-height: 42px;
}

.nav-img2 {
  display: none;
}

.nav-img-no {
  display: none;
}

.nav-img-active {
  display: block;
  animation: bounceInDowns 0.8s ease-in forwards;
}

@keyframes bounceInDowns {
  0% {
    transform: scale(1);
  }
  85% {
    transform: scale(1.3);
  }
  100% {
    transform: scale(1.2);
  }
}

.nav-main {
  margin: 0 auto;
}

.swiper-containers {
  margin-left: auto;
  margin-right: auto;
  position: relative;
  overflow: hidden;
  list-style: none;
  padding: 0;
  z-index: 1;
  width: 1460px;
}

.swiper-slides {
  position: relative;
  height: 670px;
  border-radius: 12px;
}

.item-bg {
  position: absolute !important;
  width: 1230px;
  height: 473px;
  border-radius: 12px;
  left: 50% !important;
  transform: translateX(-50%) !important;
}

.item-bg > img {
  width: 1230px;
  height: 473px;
  border-radius: 12px;
}

.swiper-wrapper {
  width: 100%;
}

#item-sign1 {
  position: absolute;
  width: 419px;
  height: 282px;
  top: 60px;
  right: 15px;
}

#item-sign1 > img {
  width: 419px;
  height: 282px;
}

.item-desc {
  position: absolute;
  top: 247px;
  left: 50%;
  margin-left: -550px;
  z-index: 10;
}

.item-desc > img {
  width: 1144px;
  height: 410px;
  overflow: hidden;
  cursor: pointer;
  object-fit: cover;
}

#item-small1 {
  position: absolute;
  top: 104px;
  left: 152px;
}

#item-small1 > img {
  width: 83px;
  height: 74px;
}

#item-sign2 {
  position: absolute;
  top: 154px;
  right: 80px;
}

#item-sign2 > img {
  width: 202px;
  height: 209px;
}

#item-small2 {
  position: absolute;
  top: 76px;
  left: 41px;
  width: 576px;
  height: 398px;
  overflow: hidden;
}

#item-small2 > img {
  width: 570px;
  height: 381px;
}

.item-flower {
  position: absolute;
  top: 15px;
  right: 99px;
}

.item-flower-img {
  width: 36px;
  height: 32px;
}

.item-other {
  position: absolute;
  top: 77px;
  right: 340px;
}

.item-other-img {
  width: 63px;
  height: 67px;
}

#item-sign3 {
  position: absolute;
  top: 50px;
  right: 80px;
}

#item-sign3 > img {
  width: 360px;
  height: 414px;
}

#item-small3 {
  position: absolute;
  top: 185px;
  left: 211px;
}

#item-small3 > img {
  width: 102px;
  height: 72px;
}

#item-sign4 {
  position: absolute;
  top: 89px;
  right: 38px;
}

#item-sign4 > img {
  width: 348px;
  height: 301px;
}

#item-small4 {
  position: absolute;
  top: 155px;
  left: 145px;
}

#item-small4 > img {
  width: 140px;
  height: 237px;
}

.item-other4 {
  position: absolute;
  top: 86px;
  left: 477px;
}

.item-other4 > img {
  width: 38px;
  height: 41px;
}

#item-sign5 {
  position: absolute;
  top: 93px;
  right: 66px;
}

#item-sign5 > img {
  width: 281px;
  height: 281px;
}

#item-small5 {
  position: absolute;
  top: 164px;
  left: 115px;
}

#item-small5 > img {
  width: 134px;
  height: 136px;
}

#item-sign6 {
  position: absolute;
  top: 63px;
  right: 53px;
}

#item-sign6 > img {
  width: 384px;
  height: 350px;
}

#item-small6 {
  position: absolute;
  top: 172px;
  left: 131px;
}

#item-small6 > img {
  width: 143px;
  height: 142px;
}

#item-sign7 {
  position: absolute;
  top: 135px;
  right: 64px;
}

#item-sign7 > img {
  width: 284px;
  height: 258px;
}

#item-small7 {
  position: absolute;
  top: 161px;
  left: 150px;
  z-index: 3;
}

#item-small7 > img {
  width: 179px;
  height: 214px;
}

.animate__backInLeft {
  animation: backInLeft 0.6s ease-out forwards;
  display: block !important;
}

.animate__backInRight {
  animation: backInRight 0.6s ease-out forwards;
  display: block !important;
}

.animate__backInUp {
  display: block !important;
  animation: backInUp 1s ease-in;
}

@keyframes backInLeft {
  0% {
    -webkit-transform: translateX(-200px) scale(0.7);
    transform: translateX(-200px) scale(0.7);
    opacity: 0.7;
  }
  80% {
    -webkit-transform: translateX(0) scale(0.7);
    transform: translateX(0) scale(0.7);
    opacity: 0.7;
  }
  to {
    -webkit-transform: scale(1);
    transform: scale(1);
    opacity: 1;
  }
}

@keyframes backInRight {
  0% {
    -webkit-transform: translateX(200px) scale(0.7);
    transform: translateX(200px) scale(0.7);
    opacity: 0.7;
  }
  80% {
    -webkit-transform: translateX(0) scale(0.7);
    transform: translateX(0) scale(0.7);
    opacity: 0.7;
  }
  to {
    -webkit-transform: scale(1);
    transform: scale(1);
    opacity: 1;
  }
}

@keyframes backInUp {
  0% {
    top: 1247px;
    opacity: 0.7;
  }
  80% {
    opacity: 0.7;
    top: 247px;
  }
  to {
    opacity: 1;
  }
}

.qr-code {
  margin: 0 auto;
  margin-top: 40px;
}

.qr-code > img {
  width: 291px;
  height: 158px;

}

.swiper-slides {
  border-radius: 1.2px;
}

.swiper-slide,
.swiper-containers {
  border-radius: 12px;
}
.swiper-button-prevs,
.swiper-container-rtl .swiper-button-nexts {
  left: 10px;
  right: auto;
}

.swiper-button-nexts,
.swiper-button-prevs {
  position: absolute;
  top: 236px;
  width: calc(var(--swiper-navigation-size) / 44 * 27);
  height: var(--swiper-navigation-size);
  margin-top: calc(-1 * var(--swiper-navigation-size) / 2);
  z-index: 10;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  color: var(--swiper-navigation-color, var(--swiper-theme-color));
}

.swiper-button-nexts,
.swiper-button-prevs {
  transition: opacity 0.3s;
}
.swiper-button-nexts>img,
.swiper-button-prevs>img {
  width: 27px;
  height: 27px;
}
.swiper-button-nexts,
.swiper-container-rtl .swiper-button-prevs {
  right: 10px;
  left: auto;
}

.swiper-button-nexts:after,
.swiper-container-rtl .swiper-button-prevs:after,
.swiper-button-prevs:after,
.swiper-container-rtl .swiper-button-nexts:after {
  display: none !important;
}
</style>